import script from "./QuickSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickSetup.vue?vue&type=script&setup=true&lang=js"

import "./QuickSetup.vue?vue&type=style&index=0&id=196f7706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-196f7706"]])

export default __exports__